import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-content',
    templateUrl: './confirm-content.component.html',
    styleUrls: ['./confirm-content.component.scss']
})
export class ConfirmContentComponent {
    @Input() message: string;
    @Input() title: string;
    @Input() options: any;

    constructor(public activeModal: NgbActiveModal) { }

    cancel() {
        this.activeModal.dismiss();
    }

    confirm() {
        this.activeModal.close();
    }
}
